import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "alarms" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = { class: "first-column-with-icon-type" }
const _hoisted_6 = { class: "name-type-block" }
const _hoisted_7 = { class: "name-data" }
const _hoisted_8 = { class: "type-data-mini" }
const _hoisted_9 = { class: "emq-table-footer" }

import { getAlarmList } from '@/api/operation'
import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { ArrowDown, ArrowUp, Refresh, RefreshLeft, Search, Plus } from '@element-plus/icons-vue'
import { pick } from 'lodash'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import AlarmRecoverStatus from '@/components/AlarmRecoverStatus.vue'
import AlarmStatus from '@/components/AlarmStatus.vue'
import AlarmLevel from '@/components/AlarmLevel.vue'
import { dateFormat } from '@/common/tools'
import LinkOperator from '@/components/Links/LinkOperator.vue'
import LinkEvse from '@/components/Links/LinkEvse.vue'


import { defineComponent, ref } from 'vue'

const __default__ = defineComponent({
  name: 'Alarms',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18nTl('Operation')

const showUser = ref({ id: '', operatorID: '' })
const showDialog = ref(false)
const showBindDialog = ref(false)
const showMoreQuery = ref(false)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({})
const { enableSelects, evseStateSelects } = useProtocolEnums()
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('evses-detail')

const editUserDialog = (row: any) => {
  showUser.value = row
  showDialog.value = true
}

const bindEvseDialog = (row: any) => {
  showUser.value = row
  showBindDialog.value = true
}

const handleSearch = async () => {
  params.value = genQueryParams(fuzzyParams.value)
  loadDatas()
}

const handleReset = () => {
  fuzzyParams.value = {}
  handleSearch()
}

const genQueryParams = (params: Record<string, any>) => {
  let newParams: Record<string, any> = {}
  const { id, operatorID, sn } = params
  newParams = {
    id: id || undefined,
    operatorID: operatorID || undefined,
    sn: sn || undefined,
  }
  return newParams
}

const loadDatas = async () => {
  lockTable.value = true
  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
    },
  }

  try {
    const { list = [], pageReply = {} } = await getAlarmList(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = list
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}

loadDatas()

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_UserBindEvse = _resolveComponent("UserBindEvse")!
  const _component_UserEditDialog = _resolveComponent("UserEditDialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          icon: _unref(Refresh),
          onClick: loadDatas
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
          ]),
          _: 1
        }, 8, ["icon"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref_key: "TableCom",
        ref: TableCom,
        "row-key": "id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "sn",
            "min-width": "80",
            label: _ctx.$t('Evses.sn'),
            show: "false",
            align: "center",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(LinkEvse, {
                id: row.evseID,
                name: `${row.sn} - ${row.cno}`
              }, null, 8, ["id", "name"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "operatorName",
            "min-width": "50",
            label: _ctx.$t('Operation.operator'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(LinkOperator, {
                id: row.operatorID,
                name: row.operatorName
              }, null, 8, ["id", "name"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "name",
            "min-width": "120",
            label: _ctx.$t('Base.name'),
            show: "false"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "solution",
            "min-width": "120",
            label: _ctx.$t('Base.solution'),
            show: "false"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "state",
            label: _ctx.$t('Base.state'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, [
                    _createVNode(AlarmStatus, {
                      state: row.state
                    }, null, 8, ["state"])
                  ]),
                  _createElementVNode("span", _hoisted_8, [
                    _createVNode(AlarmRecoverStatus, {
                      state: row.recover
                    }, null, 8, ["state"])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "level",
            label: _ctx.$t('Base.tags'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(AlarmLevel, {
                state: row.level
              }, null, 8, ["state"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "createdAt",
            "min-width": "80",
            label: _ctx.$t('Base.createdAt'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(Number(row.createdAt) * 1000)), 1)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[0] || (_cache[0] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadDatas
        }, null, 8, ["metaData"])
      ]),
      _createVNode(_component_UserBindEvse, {
        modelValue: showBindDialog.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showBindDialog).value = $event)),
        userID: showUser.value.id,
        operatorID: showUser.value.operatorID,
        onSubmitted: loadDatas
      }, null, 8, ["modelValue", "userID", "operatorID"]),
      _createVNode(_component_UserEditDialog, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showDialog).value = $event)),
        user: showUser.value,
        onSubmitted: loadDatas
      }, null, 8, ["modelValue", "user"])
    ])
  ]))
}
}

})